import styled, { keyframes } from "styled-components";

export const Wrapper = styled.div`
  padding:80px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
  }
  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`;

export const SectionHead = styled.header`
  text-align: center;
  margin-bottom: 20px;

  h2{
    font-weight: 700;
    font-style: Bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;
    text-align: center;
    display: none;
  }

  @media (min-width: 1200px){
    margin-bottom: 28px;

    h2{
      display: block;
    }
  }
`;

/* ===== mobile ===== */
export const MobileList = styled.div`
  display: grid;
  gap: 80px;

  @media (min-width: 1200px){
    display: none;
  }
`;

export const MobileCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 40px;
  text-align: left;

  h3{
    font-weight: 600;
    font-style: bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;
  }

  p{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
  }

  ul{
    list-style: none;
    margin: 0;
    display: grid;
    gap: 16px;
  }
  li{
    display: grid;
    grid-template-columns: 16px 1fr;
    align-items: center;
    column-gap: 16px;
    font-size: 14px;
    line-height: 20px;
  }

  .dot{
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: linear-gradient(135deg, #D72082 0%, #2A73FF 100%);
    flex-shrink: 0;
  }
`;

/* ===== desktop ===== */
export const DesktopGrid = styled.div`
  display: none;

  @media (min-width: 1200px){
    display: grid;
    justify-content: center;
    gap: 120px;
  }

  .texts{
    max-width: 533px;
    justify-content: center;
  }

  img{
    max-width: 533px;
    object-fit: cover;
    display: block;
    filter: contrast(1.05) saturate(1.05);
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 64px;
  align-items: center;
  max-width:1200px;

  ${({ $reverse }) => $reverse && `
    grid-template-columns: 1.05fr 0.95fr;
    & > *:first-child { order: 2; }
    & > *:last-child  { order: 1; }
  `}
`;

export const TopShadow = styled.div`
  display: none;

  @media (min-width: 1200px){
    width: 100%;
    max-width: 1200px;
    display: block;
    height: 100px;
    border-radius: 68px 68px 0 0;
    z-index: 0;

    background: linear-gradient(180deg, #001339 0%, #001234 100%);

    -webkit-mask-image: linear-gradient(to bottom,
      rgba(0,0,0,1) 0%,
      rgba(0,0,0,.9) 0%,
      rgba(0,0,0,0) 80%);
    
    mask-image: linear-gradient(to bottom,
      rgba(0,0,0,1) 0%,
      rgba(0,0,0,.9) 0%,
      rgba(0,0,0,0) 80%);

    box-shadow:
      inset 0 20px 40px rgba(0,0,0,0.35),
      0 6px 20px rgba(0,0,0,0.25);
  }
`;

/* animações de ida/volta (efeito marquee) */
const scrollLeft = keyframes` from { transform: translateX(0); } to { transform: translateX(-50%); } `;
const scrollRight = keyframes` from { transform: translateX(-50%); } to { transform: translateX(0); } `;

export const Marquee = styled.div`
  margin-top: 50px;
  width: 100%;
  max-width: 1200px;
  display: grid;
  gap: 12px;
  overflow: hidden;
  
  -webkit-mask-image: linear-gradient(90deg,
    transparent 0%,
    #000 8%,
    #000 92%, 
    transparent 100%
  );

  mask-image: linear-gradient(90deg,
    transparent 0%,
    #000 8%,
    #000 92%,
    transparent 100%);
`;

export const MarqueeRow = styled.div`
  position: relative;
  width: 100%;
  height: 65px;
  overflow: hidden;
`;

export const Track = styled.div`
  position: absolute;
  display: inline-flex;
  gap: 16px;
  white-space: nowrap;
  will-change: transform;

  /* Duplicamos os itens no JSX e animamos metade do comprimento (-50%) */
  &.left  { animation: ${scrollLeft} 22s linear infinite; }
  &.right { animation: ${scrollRight} 22s linear infinite; }

  /* pausa ao passar o mouse (opcional) */
  /* &:hover { animation-play-state: paused; } */
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 32px;
  border-radius: 64px;
  opacity: 1;
  font-weight: 600;
  font-style: bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0px;

  /* estilo dark com destaque sutil */
  background: var(--color-0b162c);
  box-shadow: inset 0 0 0 1px #0f1520, 0 2px 10px rgba(0,0,0,.25);
`;
